<template>

<app-panel-content :slim="true" :grow="true">

    <app-panel-title :text="item.name" :is-big="true" />
	
    <app-panel-summary label="Status" :tag="$constants.registration.application.statusName[item.status]" :status="$constants.registration.application.statusTheme[item.status]" :theme="$constants.registration.application.statusTheme[item.status]" />
		
	<app-panel-summary label="Ref." :value="item.reference" />
		
	<app-panel-summary label="E-mail" :value="item.email" />
    
	<app-panel-summary label="Page" :value="item.page.name" />
    
	<app-panel-summary label="Submitted on" :value="item.date.submitted | localDate('MM/DD/YYYY h:mma')" />
	
</app-panel-content>

</template>

<script>

export default {

    props: ['item']

}

</script>

<style scoped>

</style>
